import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue"
import AppPage from "@/components/layout/AppPage.vue"
import { ApplicationTrack } from "@/gql"


export default /*#__PURE__*/_defineComponent({
  __name: 'Overview',
  props: {
  applicationTrack: {
    type: Object as PropType<ApplicationTrack>,
    required: true,
  },
  buttonLabel: {
    type: String,
    default: "Begin Application",
  },
},
  emits: ["startApplication"],
  setup(__props, { emit }) {

const props = __props



const onBeginApplication = () => {
  emit("startApplication")
}


return { __sfc: true,emit, onBeginApplication, props, AppPage }
}

})